import { NavLink, matchPath, useLocation } from 'react-router-dom';

import { FunctionComponent } from 'react';
import { StringHelper } from '../../helpers';
import classNames from 'classnames';
import { routes } from '../../routers/AppRouter';
import { useTranslation } from 'react-i18next';

const Breadcrumbs: FunctionComponent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const crumbs = StringHelper.getCrumbs(location.pathname);
  const isValidPath = routes.find((route) => matchPath(route, location.pathname));
  const isPublicHome = location.pathname === '/';

  return isValidPath && !isPublicHome ? (
    <div className="breadcrumbs-bar d-flex align-items-center">
      <div className="container">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {crumbs.map((path: string, index: number) => {
              const matchedRoute = routes.find((route) => matchPath(route, path));
              const isLastElement = index === crumbs.length - 1;
              return matchedRoute ? (
                <li className={classNames('breadcrumb-item', isLastElement && 'active')} key={path}>
                  {!isLastElement ? (
                    <NavLink to={path} className="text-decoration-none text-secondary">
                      {matchedRoute.breadcrumbsIcon && <>{matchedRoute.breadcrumbsIcon}</>}
                      {t(matchedRoute.translationTag)}
                    </NavLink>
                  ) : (
                    <span className="fw-bold">
                      {matchedRoute.breadcrumbsIcon && <>{matchedRoute.breadcrumbsIcon}</>}
                      {t(matchedRoute.translationTag)}
                    </span>
                  )}
                </li>
              ) : null;
            })}
          </ol>
        </nav>
      </div>
    </div>
  ) : null;
};

export default Breadcrumbs;
